import { z } from "zod";
import { CarryOutBaseSchema } from "../generated/CarryOut";
import { GroupBaseSchema } from "../generated/Group";
import { LotBaseSchema } from "../generated/Lot";
import { MaterialBaseSchema } from "../generated/Material";
import { getUserSchema } from "./user";

const carryOutRowLotsSchema = z.array(
  LotBaseSchema.base.extend({
    Materials: MaterialBaseSchema.rows,
    User: getUserSchema.strip().nullable().optional(),
  }),
);
export const carryOutRowSchama = CarryOutBaseSchema.base.extend({
  Lots: carryOutRowLotsSchema,
  User: getUserSchema.strip(),
});

export const carryOutRowsSchama = z.array(carryOutRowSchama);

export type carryOutRowLots = z.infer<typeof carryOutRowLotsSchema>;
export type carryOutRow = z.infer<typeof carryOutRowSchama>;
export type carryOutRows = z.infer<typeof carryOutRowsSchama>;

// 出荷の正規化応答(重複排除)。従来の Lots(Materials/User込み)・User ネストを related バケットへ分離し、
// ネスト形(carryOutRow)への復元は web 側 util/hydrators/carryOutHydrator の共通ハイドレータが行う。
// キー名は IndexedDB の SetCache 収集キー(PascalCase 複数形)に合わせてある。
// related.Lots には従来 include の where(deleted_at: null)を踏襲して alive のロットのみ入る。
// 単一取得(get-carry-out-from-id)も同形(CarryOuts 配列に1件)で返し、応答組み立てを一覧取得と共有する。
export const normalizedCarryOutResponseSchema = z.object({
  CarryOuts: CarryOutBaseSchema.base.array(),
  related: z.object({
    Lots: LotBaseSchema.base.array(),
    Materials: MaterialBaseSchema.base.array(),
    // User 内の Group ネストも一般規則どおり分離する(Users は group_id 参照のみ)
    Users: getUserSchema.omit({ Group: true }).strip().array(),
    Groups: GroupBaseSchema.base.array(),
  }),
});
export type NormalizedCarryOutResponse = z.infer<typeof normalizedCarryOutResponseSchema>;
